import { reactive } from "vue";

class LoadingStateController {
  private loadingStates: Map<string, number> = new Map();

  public state;

  constructor() {
    // make it reactive so that it can be used in Vue components
    this.state = reactive({
      isLoading: false,
    });
  }

  private syncIsLoading() {
    this.state.isLoading = this.loadingStates.size > 0;
  }

  public start(id: string) {
    const currentState = this.loadingStates.get(id) || 0;
    this.loadingStates.set(id, currentState + 1);

    this.syncIsLoading();
  }

  public stop(id: string) {
    const currentState = this.loadingStates.get(id) || 0;
    const newState = currentState - 1;

    if (newState <= 0) {
      this.loadingStates.delete(id);
    } else {
      this.loadingStates.set(id, newState);
    }

    this.syncIsLoading();
  }

  public reset() {
    this.loadingStates.clear();
    this.syncIsLoading();
  }
}

export default new LoadingStateController(); // singleton
